import NextImage from 'next/image';

import cmsParser from 'Common/util/cmsParser';

import Video from 'Components/Video';

import type { Slide } from 'Components/Carousel/Carousel';

class ContentCarousel {
    static createSlides(carouselItems: any[]): Slide[] {
        return carouselItems.reduce((slides, item, index) => {
            switch (item.type) {
                case 'videoTranscript':
                    slides.push({
                        id: `youtube_transcript_${index}`,
                        element: <Video {...cmsParser.transcriptEmbed(item.value)} />
                    });
                    break;
                case 'youTubeVideo':
                    slides.push({
                        id: `youtube_video_${index}`,
                        element: <Video {...cmsParser.video(item.value)} />
                    });
                    break;
                case 'image':
                case 'images': {
                    const imageData = cmsParser.image(item.value);
                    slides.push({
                        id: `image_${index}`,
                        element: (
                            <NextImage
                                src={imageData.src}
                                alt={imageData.alt || ''}
                                width={1320}
                                height={742.5}
                                style={{ maxWidth: '100%', height: 'auto' }}
                            />
                        )
                    });
                    break;
                }
                default:
                    break;
            }
            return slides;
        }, []);
    }
}

export default ContentCarousel;
